import MainView from "./MainView";
import C_CockpitParts from "../const/C_CockpitParts";
import C_Snd from "../const/C_Snd";
import Point3D from "../core/math/Point3D";
import Button from "../core/ui/Button";
import C_PointerEvt from "../core/const/C_PointerEvt";
import C_Local from "../core/const/C_Local";


class MainViewPortrait extends MainView
{
    constructor()
    {
        super();
    }


    addBackground()
    {
        this.bg = this.assets.getSprite("room" + this.shipId + "bg", ".jpg");

        this.layout.propHeightScale(this.bg, 100 + this.config.viewPadSize);
        this.layout.verticalAlignMiddle(this.bg);
        this.layout.horizontalAlignCenter(this.bg);
        this.addChild(this.bg);

        this.deltaX = -(this.bg.width - this.layout.rect.width);
        this.deltaY = -(this.bg.height - this.layout.rect.height);
    }


    addContainers()
    {
        super.addContainers();

        // TODO fix shield masks
        // this.shieldMask = new PIXI.Graphics();
        // this.shieldMask.beginFill(0xff0000);
        // // this.shieldMask.drawCircle(this.layout.relWidth(50), this.layout.relHeight(50), this.layout.relWidth(25));
        // this.shieldMask.drawCircle(0, 0, this.layout.relWidth(25));
        // this.shieldMask.endFill();
        // this.shieldMask.x = this.layout.rect.width/2;
        // this.shieldMask.y = this.layout.rect.height/2;
        // this.addChild(this.shieldMask);
        //
        // this.shield.mask = this.shieldMask;

        // TweenMax.fromTo(this.shieldMask.scale, 1, {x: 0, y: 0, delay: 0}, {x: 1, y: 1, delay: 1});
        // performance.now();

        // TODO test renderTexture masking
        return;
        this.renderTexture = PIXI.RenderTexture.create(this.shield.width, this.shield.height);

        this.renderTextureSprite = new PIXI.Sprite(this.renderTexture);
        this.addChild(this.renderTextureSprite);
        // this.renderTextureSprite.scale.x = 10;
        // this.renderTextureSprite.scale.y = 10;

        this.shield.mask = this.renderTextureSprite;

        this.maskContainer = new PIXI.Container();
        // this.addChild(this.maskContainer);

        this.frameAnim();
    }


    addShield()
    {
        this.shield = this.assets.getSprite("cockpit" + this.shipId + "shield");
        super.addShield();
    }


    addCockpit()
    {
        this.partsPerShip = C_CockpitParts.partsPortrait;
        super.addCockpit();
    }


    addPlayerBalance()
    {
        this.balanceTF = this.assets.getTF(this.model.getBalance(), this.layout.relHeight(3));
        this.layout.horizontalAlignLeft(this.balanceTF, 12, this.cockpit);
        this.layout.verticalAlignBottom(this.balanceTF, 0.75, this.cockpit);
        this.addChild(this.balanceTF);

        this.coin = this.assets.getSprite("coin");
        this.layout.propHeightScale(this.coin, 3);
        this.coin.x = this.balanceTF.x - this.coin.width - this.layout.relWidth(1);
        this.layout.verticalAlignMiddle(this.coin, 0, this.balanceTF);
        this.addChild(this.coin);

        this.pointsWonTF = this.assets.getTF("0", this.layout.relHeight(3));
        this.layout.horizontalAlignRight(this.pointsWonTF, 24, this.cockpit);
        this.layout.verticalAlignBottom(this.pointsWonTF, 0.75, this.cockpit);
        this.addChild(this.pointsWonTF);
    }


    addButtons()
    {
        this.navButSize = 7;
        this.butPadding = 1;
        this.butHorizontalPadding = 3;
        this.backButBotPadding = 90;
        this.payButBotPadding = 82;
        this.soundButBotPadding = 90;

        // super.addButtons();

        let backButPos = [new PIXI.Point(10, 91.7), new PIXI.Point(5, 92.5), new PIXI.Point(8, 85)];
        let infoButPos = [new PIXI.Point(83.5, 91.7), new PIXI.Point(50, 98), new PIXI.Point(50, 96.5)];
        let soundButPos = [new PIXI.Point(93, 91.5), new PIXI.Point(95, 92.5), new PIXI.Point(92, 81)];
        this.butSize = [7, 7, 7];

        let backSkin = "cockpit" + this.shipId + "_backBut";
        this.backButton = new Button(backSkin);
        this.layout.propHeightScale(this.backButton, 101);
        this.layout.verticalAlignMiddle(this.backButton);
        this.layout.horizontalAlignCenter(this.backButton);
        this.backButton.setEnabled(false);
        this.addChild(this.backButton);

        this.backHit = this.assets.getSprite("target_red");
        this.layout.propHeightScale(this.backHit, this.butSize[this.shipId - 1]);
        this.backHit.anchor.set(.5, .5);
        this.backHit.x = this.layout.relWidth(backButPos[this.shipId - 1].x);
        this.backHit.y = this.layout.relHeight(backButPos[this.shipId - 1].y);
        this.addChild(this.backHit);
        this.backHit.interactive = true;
        this.backHit.alpha = 0;


        let infoSkin = "cockpit" + this.shipId + "_infoBut";
        this.paytableButton = new Button(infoSkin);
        this.layout.propHeightScale(this.paytableButton, 101);
        this.layout.verticalAlignMiddle(this.paytableButton);
        this.layout.horizontalAlignCenter(this.paytableButton);
        this.paytableButton.setEnabled(false);
        this.addChild(this.paytableButton);

        this.infoHit = this.assets.getSprite("target_red");
        this.layout.propHeightScale(this.infoHit, this.butSize[this.shipId - 1]);
        this.infoHit.anchor.set(.5, .5);
        this.infoHit.x = this.layout.relWidth(infoButPos[this.shipId - 1].x);
        this.infoHit.y = this.layout.relHeight(infoButPos[this.shipId - 1].y);
        this.addChild(this.infoHit);
        this.infoHit.interactive = true;
        this.infoHit.alpha = 0;


        let soundSkin = "cockpit" + this.shipId + "_sound";
        soundSkin += this.localData.getBooleanValue(C_Local.SOUND_ENABLED, this.soundEnabled) ?
                        "On" : "Off";
        this.soundButton = new Button(soundSkin);
        this.layout.propHeightScale(this.soundButton, 101);
        this.layout.verticalAlignMiddle(this.soundButton);
        this.layout.horizontalAlignCenter(this.soundButton);
        this.soundButton.setEnabled(false);
        this.addChild(this.soundButton);

        this.soundHit = this.assets.getSprite("target_red");
        this.layout.propHeightScale(this.soundHit, this.butSize[this.shipId - 1]);
        this.soundHit.anchor.set(.5, .5);
        this.soundHit.x = this.layout.relWidth(soundButPos[this.shipId - 1].x);
        this.soundHit.y = this.layout.relHeight(soundButPos[this.shipId - 1].y);
        this.addChild(this.soundHit);
        this.soundHit.interactive = true;
        this.soundHit.alpha = 0;

        this.backHit.on(C_PointerEvt.DOWN, this.onGoMenuConfirm, this);
        this.infoHit.on(C_PointerEvt.DOWN, this.onPaytable, this);
        this.soundHit.on(C_PointerEvt.DOWN, this.onSoundTrigger, this);

        let cursor = "url('styles/custom_cursor1.png') 5 5, auto";
        this.backHit.on(C_PointerEvt.OVER, () => {
            this.backOver = true;
            this.setCursor(cursor);
            this.reticle.alpha = 0;
        }, this);
        this.backHit.on(C_PointerEvt.OUT, () => {
            this.backOver = false;
            if (!this.infoOver && !this.soundOver && !this.popupOpened)
            {
                this.setCursor("none");
                this.reticle.alpha = 1;
            }
        }, this);

        this.infoHit.on(C_PointerEvt.OVER, () => {
            this.infoOver = true;
            this.setCursor(cursor);
            this.reticle.alpha = 0;
        }, this);
        this.infoHit.on(C_PointerEvt.OUT, () => {
            this.infoOver = false;
            if (!this.backOver && !this.soundOver && !this.popupOpened)
            {
                this.setCursor("none");
                this.reticle.alpha = 1;
            }
        }, this);

        this.soundHit.on(C_PointerEvt.OVER, () => {
            this.soundOver = true;
            this.setCursor(cursor);
            this.reticle.alpha = 0;
        }, this);
        this.soundHit.on(C_PointerEvt.OUT, () => {
            this.soundOver = false;
            if (!this.backOver && !this.infoOver && !this.popupOpened)
            {
                this.setCursor("none");
                this.reticle.alpha = 1;
            }
        }, this);
    }


    addFireNotification()
    {
        super.addFireNotification();

        this.layout.propHeightScale(this.autoFire, 6);
        this.layout.horizontalAlignCenter(this.autoFire);
        this.layout.verticalAlignTop(this.autoFire, 15);

        this.layout.propHeightScale(this.autoAim, 6);
        this.layout.horizontalAlignCenter(this.autoAim);
        this.layout.verticalAlignTop(this.autoAim, 15);

        // TweenMax.to(this.autoFire, 0.5, {alpha: 0, yoyo: true, repeat: -1, ease:Power3.easeIn});
    }


    showBonusScreenText(text)
    {
        let tf = this.assets.getTF(text, this.layout.relHeight(15), null, null, null, this.layout.relWidth(60));
        this.layout.horizontalAlignCenter(tf);
        this.layout.verticalAlignMiddle(tf);
        tf.alpha = 0;
        this.addChild(tf);

        TweenMax.to(tf, 0.5, {alpha: 1});
        TweenMax.to(tf, 0.5, {alpha: 0, delay:4.5});
    }


    onSoundTrigger(e)
    {
        if (e)
        {
            e.stopPropagation();
        }

        this.sound.toggleMusic();
        this.sound.toggleSound();

        let soundSkin = "cockpit" + this.shipId + "_sound";
        soundSkin += this.localData.getBooleanValue(C_Local.SOUND_ENABLED, this.soundEnabled) ?
            "On" : "Off";
        this.soundButton.setSkins(soundSkin, soundSkin, soundSkin, soundSkin);
    }


    onPlayerHit(position)
    {
        this.app.layout.shake(this, .2, this.shakeAmplitude, this.shakeAmplitude, .9, 0);
        this.sound.playSound(C_Snd.SHIELD_HIT);
        TweenMax.to(this.shield, .1, {alpha:1, overwrite:1});
        TweenMax.to(this.shield, .1, {alpha:0.5, delay:.15});

        // TODO fix shield hit
        return;
        // console.log(position);
        position = new Point3D(0, 0, 5); // testing
        let screenPos = this.layout.projectGameToScreen(position);
        console.log(screenPos);

        // TweenMax.killTweensOf(this.shieldMask);
        // this.shieldMask.clear();
        // this.shieldMask.beginFill(0x000000);
        // this.shieldMask.drawCircle(0, 0, this.layout.relHeight(20));
        // this.shieldMask.endFill();
        // this.shieldMask.x = this.layout.rect.width/2;
        // this.shieldMask.y = this.layout.rect.height/2;
        // console.log(this.shieldMask.width);

        // this.app.renderer.render(this.shieldMask, )


        TweenMax.to(this.shield, .1, {alpha:1, overwrite:1});
        TweenMax.to(this.shield, .1, {alpha:0, delay:.1});

        // TweenMax.fromTo(this.shieldMask.scale, .1, {x: 0, y: 0}, {x: 1, y: 1, overwrite: 1});
    }


    frameAnim()
    {
        performance.now();
        if (this.maskContainer.children.length < 5)
        {
            let circle = this.createCircle();
            this.maskContainer.addChild(circle);
            TweenMax.to(circle.scale, 1, {x: 1, y: 1, delay: 1, onComplete: this.clearCircle.bind(this), onCompleteParams: [circle]});
        }

        this.app.renderer.render(this.maskContainer, this.renderTexture, true, null, false);

        requestAnimationFrame(this.frameAnim.bind(this));
    }


    createCircle()
    {
        let brush = new PIXI.Graphics();
        brush.beginFill(0xff0000);
        brush.drawCircle(0, 0, 100);
        brush.endFill();

        brush.x = Math.random()*this.shield.width;
        brush.y = Math.random()*this.shield.height;

        // brush.x = 0.5*this.shield.width;
        // brush.y = 0.5*this.shield.height;

        brush.scale.x = 0;
        brush.scale.y = 0;

        // TweenMax.fromTo(brush.scale, 1, {x: 0, y: 0, delay: 0}, {x: 1, y: 1, delay: 1});


        return brush;
    }

    clearCircle(circle)
    {
        console.log(this.maskContainer.children.length);
        this.maskContainer.removeChild(circle);
    }
}

export default MainViewPortrait;